export default "__VITE_ASSET__vKDv5YSV__";